import Vue from 'vue';
import {Component, Watch} from 'vue-property-decorator'
import { Getter, Action, Mutation } from 'vuex-class'

import Header from '@/components/header/header'
import CheckoutAddressSchedule from '@/components/checkoutAddressSchedule/checkoutAddressSchedule'
import CheckoutPayment from '@/components/checkoutPayment/checkoutPayment'
import CheckoutProducts from '@/components/checkoutProducts/checkoutProducts'
import CheckoutSumary from '@/components/checkoutSumary/checkoutSumary'
import Loading from '@/components/loading/loading'
import ModalOkCancel from '@/components/modalOkCancel/modalOkCancel';
import CashbackNotification from '@/components/cashbackNotification/cashbackNotification';

import { segment_track, parseSpecialCharacters } from '@/settings/segment'
import { cityParser } from '@/plugins/city_parser'
import moment from 'moment';

@Component({
  components: {
    Header,
    CheckoutAddressSchedule,
    CheckoutPayment,
    CheckoutProducts,
    CheckoutSumary,
    Loading,
    ModalOkCancel,
    CashbackNotification
  },
  beforeRouteEnter(to: any, from: any, next: any) {
    next((vm) => {
      if (!vm.getIsToken) {
        const name = to.name
        const query = to.query
        const params = to.params
        vm.PATH_TEMPORAL({ name, params, query });
        if(from.name === 'login') {
          next({ name: 'root'});
        } else {
          next('/login');
        }
      } else {
        next();
        if (vm.getPseStatus) {
          next();
          vm._alertPse()
        }
      }
    })
  }
})
export default class NewCheckout extends Vue {

  // Actions
  @Action action_getCart: any;
  @Action action_postOrder: any;
  @Action action_cleanCart: any;
  @Action action_postCart: any;
  @Action action_postCartProducts: any;
  @Action action_removeCartProducts: any;
  @Action action_postCouponsAtivate;
  @Action action_getAcceptanceToken;
  @Action action_getCountry
  @Action action_getCity
  @Action action_getUser
  @Action action_isOnDemandValid;

  // Mutation
  @Mutation CURRENT_ADDRESS;
  @Mutation CART_TEMPORAL;
  @Mutation CART;
  @Mutation CARTPRODUCTS;
  @Mutation PATH_TEMPORAL;
  @Mutation PSE_STATUS;
  @Mutation SPINNER;
  @Mutation TEMPORAL_COUPON;
  @Mutation CURRENT_PAYMENT_METHOD
  @Mutation CART_DELETED_PRODUCTS;
  @Mutation IS_ON_DEMAND_VALID;
  @Mutation CURRENT_CITY_ZONE;

  // Getters
  @Getter getCart;
  @Getter getTemporalCoupon;
  @Getter getCartProducts;
  @Getter getCartTemporal;
  @Getter getIsToken;
  @Getter getUser;
  @Getter getCity;
  @Getter getPseStatus;
  @Getter getPseInformation;
  @Getter getIsTestUser;
  @Getter getCreditCards;
  @Getter getDonationProducts;
  @Getter getCurrentProgram;
  @Getter getCurrentAddress;
  @Getter getCountry;
  @Getter getCartDeletedProducts;
  @Getter getIsOnDemandValid;


  // evento del before route leave
  next = () => {};

  isShowCartClear = false;
  // donation
  donation = {
    name: null,
    cellphone: null,
    type: "fundation"
  };
  // programar pedido
  workingDay = null;
  dayProgram = null;
  // direccion
  address = null;
  address_info = null;
  // metodo de pago
  payment = null;
  pse_info = null;
  // validar campos obligatorios
  validate = [];
  // wompi terminos
  token_info = {};
  // modal de direcciones
  showAddressModal = false;

  pageLoaded = false;
  loadingCart = false;

  addAddress = false;
  addProgram = false;
  currentCoupon = null;
  isCreatingOrder = false;
  isLoadingImportantInfo = false;
  orderComment = "";
  deleteProductsText = "";
  showDeletedProductsModal = false;

  showCashbackMessage = true;

  get getCurrentCartProducts() {
    return this.getCartProducts;
  }

  @Watch('getCurrentAddress', { deep: true })
  async onCurrentAddressChange() {
    this.isLoadingImportantInfo = true;
    try {
      if(this.getCurrentAddress && this.getCurrentAddress.id) {
        this.IS_ON_DEMAND_VALID(null);
        await this.action_isOnDemandValid(this.getCurrentAddress.id);
      }
    } catch (error) {
      let msg = "";
      if(error.response && error.response.data && error.response.data.message) {
        msg = `Error: ${error.response.data.message}`;
      }
      this.$swal({
        title: "Error",
        text: "¡Ups! Hubo un error de nuestra parte." + 
        " Por favor, intenta de nuevo. " + msg
      });
    }
    this.isLoadingImportantInfo = false;
  }

  selectFirstAddress() {
    if (Object.keys(this.getUser).length && this.getUser.addresses.length > 0) {
      if(!this.getCurrentAddress) {
        this.CURRENT_ADDRESS(this.getUser.addresses[0]);
      }
    }
  }

  onReturnButtonClick() {
    this.$router.replace({ name: "root" });
  }

  async mounted() {
    this.addAddress = false;
    this.IS_ON_DEMAND_VALID(null);
    await this.getImportantInfo();
    this.token_info = await this.action_getAcceptanceToken();
    if (this.getIsToken) {
      this.selectFirstAddress();
    }
    this.onCurrentAddressChange();
  }

  async getImportantInfo() {
    this.isLoadingImportantInfo = true;
    try {
      if (!this.getCountry) {
        await this.action_getCountry();
      }
      await this.action_getCity(this.getCity.id);
      await this.action_getUser();
      if(this.getCurrentAddress && this.getCurrentAddress.zone_id) {
        const zone = this.getCityZoneById(this.getCurrentAddress.zone_id);
        this.CURRENT_CITY_ZONE(zone);
      }
    } catch(error) {
      this.$swal({
        title: "¡Error!",
        text:
          "No se pudo cargar la información para realizar el pago." + 
          "Por favor, inténtalo de nuevo y, si el problema persiste," + 
          "comunícate con nosotros a través de nuestro chat."
      });
      this.$router.replace({ name: 'root' });
    }
    this.isLoadingImportantInfo = false;
  }

  private getCityZoneById(zoneId) {
    let res = null;
    if(this.getCity && this.getCity.zones) {
      for(let i=0; i < this.getCity.zones.length && !res; i++) {
        if(this.getCity.zones[i].id === zoneId) {
          res = this.getCity.zones[i];
        }
      }
    }
    return res;
  }

  async _resetCart() {
    this.loadingCart = true;
    try {
      
      await this.action_cleanCart();
      const cart = this.getCartTemporal.map((item) => {
        return {
          product_id: item.product.id,
          comments: "",
          qty: item.qty
        };
      });
      const requestObject = {
        products: cart,
        commerce_id: this.getCity.id
      };
      await this.action_postCart(
        requestObject
      );
      this.loadingCart = false;
      return Promise.resolve(true);
    } catch {
      this.loadingCart = false;
      return Promise.reject(false);
    }
  }

  _setPayment(value) {
    this.payment = value;
    this.CURRENT_PAYMENT_METHOD(value);
  }

  _validateField() {
    this.workingDay = "1pm-8pm";
    let validate = [];

    if (
      this.payment &&
      this.payment.type === "credit_card" &&
      (!this.payment.card.is_womp_allowed && this.payment.card.processor != "conekta")
    ) {
      validate.push({
        type: "Método de pago",
        value: "Tarjeta inválida"
      });
    }

    if (this.getCart.has_donation) {
      if (this.donation.type === "referred") {
        if (!this.donation.name) {
          validate.push({
            type: "Nombre del referido",
            value: "Campo obligatorio"
          });
        }
        if (!this.donation.cellphone) {
          validate.push({
            type: "Celular del referido",
            value: "Campo obligatorio"
          });
        }
      }
    }

    if (!this.getCart.only_donation) {
      // valdiar campo donde esta ubicado

      if (!this.getCurrentProgram) {
        validate.push({
          type: "Programar pedido",
          value: "Día obligatorio"
        });
      }
      if (this.getCity && this.getCity.schedules_to_deliver.length > 0 && !this.workingDay) {
        validate.push({
          type: "Programar pedido",
          value: "Jornada obligatoria"
        });
      }

      // valdiar campo donde esta ubicado
      // if (this.getIsTestUser) {
      if (!(this.getCurrentAddress && (this.getCurrentAddress as any).id)) {
        validate.push({
          type: "Entregar en",
          value: "Todos los campos obligatorios"
        });
      }
    }
    // valdiar campo de pago
    if (!this.payment) {
      validate.push({
        type: "Método de pago",
        value: "Metodo de pago obligatorio"
      });
    }
    
    if (this.payment && this.payment.type === "pse" && !this.getPseInformation) {
      validate.push({
        type: "Formulario PSE",
        value: "Todos los campos son obligatorios"
      });
    }

    this.validate = validate;

    return validate.length === 0 ? true : false;
  }

  async _createOrder() {
    this.isCreatingOrder = true;
    try {
      if (this._validateField()) {
        if (this.payment && this.payment.type === "pse") {
          this.pse_info = this.getPseInformation;
        }

        const res_order: any = await this._sendOrderRequest();

        this._sendSegmentRequest(res_order);

        this.SPINNER(false);

        // @ts-ignore
        this.$ga.event("Checkout", "Pago", "Hacer pedido");

        this.CART_TEMPORAL([]);
        this.CARTPRODUCTS([]);
        this.CART(null);

        if (res_order.pse_charge) {
          const has_pse = res_order.pse_charge;
          if (has_pse) {
            location.href = has_pse;
          } else {
            this.$swal({
              title: "Error al generar orden...",
              text: `${has_pse.text_response} -- payment ${this.payment.type}`
            });
            this.isCreatingOrder = false;
          }
        } else {
          this.TEMPORAL_COUPON(null);
          this.$router.replace({ name: "history_orders" });
        }
        
      }
    } catch (error) {
      this.SPINNER(false);
      const status = error && error.response && error.response.status;
      if (status >= 500) {
        this.$swal({
          title: "Error al generar orden...",
          text: `Problemas con el servidor. Error ${status} -- payment ${this.payment.type}`
        });
      } else {
        const data = error && error.response && error.response.data;
        if (data.order_id && data.payment_link) {
          this.TEMPORAL_COUPON(null);
          this.CART(null);
          this.$router.replace({ name: "history_orders", query: { payment_failed: 'true' }});
        } else {
          this.$swal({
            title: "Error al generar orden...",
            text: `${data.message} -- payment ${this.payment.type}`
          });
        }
      }
      this.isCreatingOrder = false;
    }
  }

  async _sendOrderRequest() {

    const creditCardId = this.payment.type === "credit_card" ? this.payment.value : null;
    if (this.getCity && this.getCity.schedules_to_deliver.length == 0) {
      this.workingDay = "1pm-8pm";
    }

    let program = null;
    if (this.getCurrentProgram.day && this.getCurrentProgram.hourRange) {
      const momentDay = moment(this.getCurrentProgram.day);
      const programDay = momentDay.format("DD/MM/YYYY");
      program = {
        day: programDay,
        workingDay: this.getCurrentProgram.hourRange
      };
    }

    let donation = null;
    if (this.donation) {
      donation = this.donation;
    }

    let data = {
      order: {
        cellphone: this.getCart.cellphone,
        is_takeout: false,
        pay_with_ucoins: false,
        cash: "",
        programmed_for: null,
        description: `Pedido en ${this.getCity.commercial_name}`,
        address: this.address,
        address_info: this.address_info,
        address_id: this.getCurrentAddress && (this.getCurrentAddress as any).id,
        payment_type: this.payment.type,
        credit_card_id: creditCardId,
        acceptance_token: (this.token_info as any).acceptance_token,
        program,
        donation,
        pse_info: this.pse_info,
        appeareance: this.orderComment
      }
    };
    this.SPINNER(true);
    
    const res = await this.action_postOrder(data);
    if(res && res.data) {
      return res.data;
    }
  }

  _sendSegmentRequest(res_order) {
    let segment_products = [];
    this.getCart.cart_products.forEach((x) => {
      if (!segment_products.map((y) => y.id).includes(x.id)) {
        segment_products.push({ id: x.product_id, category_id: x.category_id });
      }
    });

    const segment_info = {
      total: parseSpecialCharacters(this.getCart.total),
      coupon: this.getCart.coupon_applied ? this.getCart.coupon : "",
      discount: parseSpecialCharacters(this.getCart.discount),
      currency: this.getCart.instance_currency,
      products: segment_products,
      order_id: (res_order as any).id,
      applied_promos_value: (res_order as any).applied_promos_value,
      is_user_first_order: (res_order as any).res_order
    };
    segment_track("order", segment_info);
  }

  _editCart() {
    const city_id = cityParser(this.getCity.commercial_name);
    this.$router.push({
      name: "superCategories",
      query: { modalOpen: "true" },
      params: { city_id: city_id }
    });
  }

  _pixelData(values: any) {
    // eslint-disable-next-line
    if ((window as any).fbq) {
      (window as any)
        .fbq("track", "Purchase", {
          content_ids: values.id,
          content_name: values && values.commerce && values.commerce.commercial_name,
          contents: [...values.json_products],
          num_items: values && values.json_products.length,
          currency: values && values.instance_currency,
          value: values && values.total
        })(
          // eslint-disable-next-line
          window as any
        )
        .fbq("track", "AddPaymentInfo", {
          content_ids: values.id,
          content_category: values && values.payment_type,
          currency: values && values.instance_currency,
          value: values.total
        });
    }
  }

  _toggleAddressModal() {
    this.showAddressModal = !this.showAddressModal;
  }

  _toggleCartClear() {
    this.isShowCartClear = !this.isShowCartClear;
  }

  _alertPse() {
    this.$swal({
      title: "Error en el último pago con PSE",
      text: `El error fue el siguiente "${
        this.getPseStatus.data.respuesta
      }" espera unos segundos y vuelve a intentar`
    });
    this.PSE_STATUS(null);
  }

  updateCart(loading) {
    this.loadingCart = loading;
  }

  async removeProduct(productId) {
    this.loadingCart = true;
    try {
      await this.action_removeCartProducts(productId);
    } catch (error) {
    }
    this.loadingCart = false;
  }

  _onCompleteOrder() {
    this._createOrder();
  }

  _onAddAddress() {
    this.addAddress = !this.addAddress;
  }

  _onAddProgram() {
    this.addProgram = !this.addProgram;
  }

  _onAddressAdded() {
    this.addAddress = false;
  }

  updateCoupon(coupon) {
    this.currentCoupon = coupon;
  }

  _onOrderComment(comment) {
    this.orderComment = comment;
  }

  @Watch('getCartDeletedProducts', { deep: true })
  onCartDeletedProductsChange() {
    if (this.getCartDeletedProducts.length > 0) {
      const deletedProducts = [...this.getCartDeletedProducts];
      let deletedProductsString =
        "Algunos de los productos en tu carrito" +
        " ya <strong>no se encuentran disponibles:</strong><br><br>";
      for (let i = 0; i < deletedProducts.length; i++) {
        if (i === deletedProducts.length - 1) {
          deletedProductsString += "- " + deletedProducts[i];
        } else {
          deletedProductsString += "- " + deletedProducts[i] + "<br>";
        }
      }
      this.deleteProductsText = deletedProductsString;
      this.showDeletedProductsModal = true;
      this.CART_DELETED_PRODUCTS([]);
    }
  }

  onDeleteProductsAccept() {
    this.showDeletedProductsModal = false;
    this.deleteProductsText = "";
  }
}